import React from "react";
import Layout from "../components/dashboard/dashboardLayout/Layout";

const Dashboard = () => {
  return (
    <div className="h-screen">
      <Layout />
    </div>
  );
};

export default Dashboard;
